"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TailwindTheme = void 0;
var _resolveConfig = _interopRequireDefault(require("tailwindcss/resolveConfig"));
var _tailwind = _interopRequireDefault(require("../../tailwind.config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TailwindTheme = (0, _resolveConfig.default)(_tailwind.default).theme;
exports.TailwindTheme = TailwindTheme;